import { http } from './config'

export default {
  saveManualPalletizedProducts: (palletizedProducts, orderId) => {
    
    return http.post('save_manual_palletized_products', {
      bays: palletizedProducts,
      orderId: orderId
    })
  }
}
